import React, { useEffect, useState } from "react";
import { mergeRight } from "ramda";
import Grid from "@mui/material/Grid";
import { Box, Card } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import { logOut } from "../../auth/authActions";
import { useDispatch, useSelector } from "react-redux";
import { useUsers } from "../../user-admin/userServices";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { notBlank } from "../../util/ext";

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: 185,
    height: "100%",
    width: "100%",
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    borderRadius: 20,
    color: theme.palette.secondary.contrastText,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },

  count: {
    marginRight: theme.spacing(1),
  },

  h1: {
    fontSize: "4.0rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },

  h4: {
    fontSize: "1.8rem",
    lineHeight: "2.2rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },

  body1: {
    fontSize: "1.2rem",
    textTransform: "uppercase",
  },

  body2: {
    fontSize: "1.2rem",
    lineHeight: "1.8rem",
    fontStyle: "italic",
  },

  addButton: {
    fontSize: "1.2rem",
    lineHeight: "1.6rem",
    fontWeight: "bold",
    paddingTop: 0,
  },
}));

const initialSearchState = {
  appliedFilter: [],
  appliedOrganization: null,
  orderBy: "accountName",
  orderDirection: "asc",
  roles: ["ROLE_CREATOR_MANAGER", "ROLE_CREATOR_USER", "ROLE_CONTENT_MANAGER"],
  activeOnly: false,
  page: 0,
};

const CreatorUsersCard = () => {
  const classes = useStyles();
  const auth = useSelector(state => state.auth);
  const reduxDispatch = useDispatch();

  //-- Handle Search state
  const [state, setState] = useState(initialSearchState);

  const searchResults = useUsers(
    state.appliedFilter,
    state.roles,
    state.appliedOrganization,
    `${state.orderBy}:${state.orderDirection}`,
    state.activeOnly,
    state.page,
  );

  useEffect(() => {
    console.log("########## Current Organization Changed!");
    console.log(auth);
    if (notBlank(auth) && notBlank(auth.currentOrganization)) {
      const organizationId = auth.currentOrganization.id;
      setState(prev =>
        mergeRight(prev, {
          appliedOrganization: organizationId,
        }),
      );
    } else {
      setState(initialSearchState);
    }
  }, [auth, auth.currentOrganization]);

  useEffect(() => {
    if (searchResults.isError) {
      //-- Send user to login if the token has expired or not logged in
      if (searchResults.error.status === 401) {
        reduxDispatch(logOut());
      }
    }
  }, [searchResults.isError, searchResults.error, reduxDispatch]);

  return (
    <Card classes={{ root: classes.root }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography
            variant="h4"
            component="span"
            classes={{ h4: classes.h4 }}
          >
            Creator Users
          </Typography>
        </Grid>
      </Grid>
      {searchResults.isSuccess ? (
        <Box mt={1}>
          <Grid
            container
            justifyContent="space-between"
            spacing={1}
            direction="column"
          >
            <Grid item>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography
                  variant="h1"
                  component="div"
                  classes={{ h1: classes.h1 }}
                >
                  {searchResults.data.count.toLocaleString()}
                </Typography>
              </Box>
            </Grid>

            <Grid item>
              <Button
                size="small"
                classes={{
                  textSizeSmall: classes.addButton,
                  iconSizeSmall: classes.addButton,
                }}
                variant="text"
                color="primary"
                startIcon={<AddIcon fontSize="small" />}
              >
                Add New
              </Button>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box>
          <Typography
            variant="h4"
            component="span"
            classes={{ h4: classes.h4 }}
          >
            Loading...
          </Typography>
        </Box>
      )}
    </Card>
  );
};

export default CreatorUsersCard;
